import { CaseCard } from './CaseCard';

export function CaseGrid({ cases, userSessions }) {
  if (!cases || cases.length === 0) {
    return (
      <div className="py-20 text-center border-2 border-dashed border-slate-200 rounded-3xl">
        <h3 className="text-lg font-bold text-slate-700 mb-2">No cases found</h3>
        <p className="text-slate-500">Adjust your search or filters to see more results.</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-6">
      {cases.map(caseItem => {
        // Find if user has a session for this case
        const session = userSessions?.find(s => s.case_id === caseItem.case_id);
        const attemptsCount = userSessions?.filter(s => s.case_id === caseItem.case_id).length || 0;
        
        return (
          <CaseCard 
            key={caseItem.case_id} 
            data={caseItem} 
            userStatus={session} 
            attemptsCount={attemptsCount}
          />
        );
      })}
    </div>
  );
}
